import {
  gridSizeConst10,
  gridSizeConst3,
  gridSizeConst9,
  gridSizeMdLg12,
} from "@/shared";
import {
  CustomTextField,
  SingleButton,
  TabTextLabel,
} from "@/shared/components/ui";
import {
  Alert,
  Button,
  Grid,
} from "@mui/material";
import { FieldArrayWithId, UseFieldArrayAppend, UseFieldArrayRemove, UseFormReturn } from "react-hook-form";
import { IProspectoPymes } from "@/shared/interfaces/erp/ventas_pymes/prospecto_pymes.interface";
import { CoordenadasPymesDefault, IPreventaPymesForm } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface";
import AddIcon from "@mui/icons-material/Add";
import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";

interface TabResidenciaPreventaProps {
  dataProspecto: IProspectoPymes | null
  editSupervisor: boolean
  form: any; // PERF: UseFormReturn<IPreventaPymesForm> instanciaba Path<T> caro en el tsc
  checkCoverage: (coordenada: string, index: number) => Promise<void>
  fields: FieldArrayWithId<IPreventaPymesForm, "items", "id">[]
  append: UseFieldArrayAppend<IPreventaPymesForm, "items">
  remove: UseFieldArrayRemove
}

export default function TabResidenciaPreventaPymes({
  form,
  checkCoverage,
  fields, append, remove
}: TabResidenciaPreventaProps) {


  const {
    formState: { errors }
  } = form

  return (
    <>
      <Grid container spacing={3}>
        <Grid
          item
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          {...gridSizeConst9}
        >
          <TabTextLabel
            text={'Punto de enlace'}
            mt={0}
            pb={4}
            pl={0}
            pt={0}
          />


        </Grid>

        <Grid item {...gridSizeConst3}>
          <SingleButton
            color={"primary"}
            variant="outlined"
            label={"Agregar"}
            startIcon={<AddIcon />}
            onClick={() => {

              append({
                coordenada: CoordenadasPymesDefault,
                nombre: '',
                estado: false,
                cobertura: false,
                valor_plan: '',
                codigo: '',
                direccion: '',
                plan: null,
                velocidad_subida_maxima: '0'
              })

              checkCoverage(CoordenadasPymesDefault, form.getValues().items?.length! - 1);

            }}
          />
        </Grid>




        {fields.map((field, index) => {

          //checkCoverage(`items.${index}.coordenada`, index);
          const itemErrors = errors.items?.[index];

          return (
            <Grid
              key={field.id}
              container item
              spacing={3}
            >

              <Grid item xs={12}>
                <TabTextLabel
                  text={`Enlace ${index + 1}`}
                  mt={0}
                  pb={1}
                  pl={0}
                  pt={0}
                />

              </Grid>
              <CustomCoordendasForm
                size={gridSizeConst10}
                //key={field.id}
                label={`Punto de enlace`}
                //name={`coordenada_${index}`}
                defaultValue={field.coordenada}
                name={`items.${index}.coordenada`}
                form={form}
                onlyValueLocation={true}
                handleDataUbicacion={(cord) => {
                  // Cada vez que cambie la coordenada, chequeamos
                  checkCoverage(cord, index);
                }}
              />

              <Grid item xs={2}>

                <Button
                  color="secondary"
                  onClick={() => {
                    remove(index)
                  }}
                  disabled={fields.length === 1}
                >
                  Eliminar
                </Button>
              </Grid>


              <CustomTextField
                name={`items.${index}.nombre`}
                type='text'
                label={`Nombre del Enlace`}
                defaultValue={field.nombre}
                control={form.control}
                error={!!itemErrors?.nombre}
                helperText={itemErrors?.nombre?.message}
                size={gridSizeMdLg12}
              />

              <CustomTextField
                name={`items.${index}.direccion`}
                type='text'
                label={`Dirección`}
                defaultValue={field.direccion}
                control={form.control}
                error={!!itemErrors?.direccion}
                helperText={itemErrors?.direccion?.message}
                size={gridSizeMdLg12}
              />

              {/* Si hay cobertura para este field.id, mostramos el Alert */}
              {form.watch(`items.${index}.cobertura`) ? (
                <Grid item {...gridSizeMdLg12}>
                  <Alert variant="outlined" severity="success">
                    Cajas disponibles para las coordendas asignadas
                  </Alert>
                </Grid>
              ) :
                (
                  <Grid item {...gridSizeMdLg12}>
                    <Alert variant="outlined" severity="warning">
                      Sin cajas disponibles para las coordendas asignadas
                    </Alert>
                  </Grid>
                )
              }

            </Grid>
          )
        })}

      </Grid>


    </>
  );
}
